import {Button, Col, Form, Radio, Row, Space, Spin, Typography} from "antd";
import {PrintColorWhiteSVG} from "assets";
import {InputFields, ModalCustom, Notification} from "components/common";
import React, {useEffect, useRef, useState} from "react";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {setButtonsHeader} from "redux/reducer/common";
import {columns, columnsThanhToan, fields as fieldsInit} from "./config";
import TableInputAdd from "./TableInputAdd/TableInputAdd";
import UploadHoSo from "./UploadFileHoSo/UploadFileHoSo";
import {FORMAT_TIME, LOAI_FORM, tabKeys} from "types/enums";
import {
  getDetailProposePay,
  getDetailProposeShopping,
  getListDongNganSach,
  getListDuAn,
  getListNguonThanhToan,
  getListNhaCungCap,
  setDetailPay,
  setTypeFormPay,
} from "redux/reducer/proposeShopping";
import {
  capitalizeFirstLetter,
  convertCurrencyToWords,
  convertDateStringToDateTimezone_7,
  formatDateToString,
  formatDateToStringTimezone_7,
  formatToCurrencyTypeToFixed,
  getItemLocalStorage,
  isValuable,
  randomId,
  toArray,
  toNumber,
} from "helper/common";
import {shoppingService} from "api";
import ModalSend from "./ModalSend/ModalSend";
import ModalApprove from "./ModalApprove/ModalApprove";
import ModalDeny from "./ModalDeny/ModalDeny";
import {TRANG_THAI_MUA_SAM} from "types/enums/shopping";
import ReceiptModal from "../ReceiptModal/ReceiptModal";
import "./DetailProposePay.scss";
import ReceiptShoppingModal from "./ReceiptShoppingModal/ReceiptShoppingModal";
import TableInputAddThanhToan from "./TableInputAddThanhToan/TableInputAdd";
const DetailProposePay = () => {
  const dispatch = useAppDispatch();
  const [formThanhToan] = Form.useForm();
  const [tongTien, setTongTien] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [dataTable, setDataTable] = useState([]);
  const [form] = Form.useForm();
  const thucChi = Form.useWatch("thucChi", form);
  const tamUng = Form.useWatch("soTienTamUng", form);
  const activeTab = useAppSelector(state => state.common.activeTab);
  const {idProposePay, typeFormPay, detailProposePay, listNhaCungCap} =
    useAppSelector(state => state.proposeShopping);
  const [tienDu, setTienDu] = useState<any>(0);
  const [fields, setFields] = useState(fieldsInit);
  const [idSelectedItem, setIdSelectedItem] = useState<any>(null);
  const modalSendRef = useRef(null);
  const modalApproveRef = useRef(null);
  const modalDenyRef = useRef(null);
  const modalPrintRef = useRef(null);
  const modalShoppingPrintRef = useRef(null);
  const nhaCungCapName = Form.useWatch("nhaCungCap", form);
  const modalUploadRef = useRef<any>(null);
  useEffect(() => {
    if (activeTab == tabKeys.PROPOSE_PAY.DETAIL) {
      dispatch(getListNhaCungCap({page: 1, limit: 50}));
      dispatch(getListDongNganSach());
      dispatch(getListNguonThanhToan());
      dispatch(getListDuAn());
    }
  }, [activeTab]);
  useEffect(() => {
    const setOptionsNhaCungCap = listNhaCungCap => {
      fields.find(e => e?.name == "nhaCungCap").options = listNhaCungCap?.map(
        e => ({
          label: e?.name,
          value: e?.name,
          key: randomId(),
        })
      );
      setFields([...fields]);
    };
    setOptionsNhaCungCap(listNhaCungCap);
  }, [listNhaCungCap]);
  useEffect(() => {
    const setFieldsValueByNhaCungCap = nhaCungCapName => {
      const nhaCungCap = listNhaCungCap.find(e => e.name == nhaCungCapName);

      const tkThuHuong = nhaCungCap?.soTaiKhoan;
      const nganHang = nhaCungCap?.nganHang;
      form.setFieldValue("nguoiThuHuong", nhaCungCapName);
      form.setFieldValue("tkThuHuong", tkThuHuong);
      form.setFieldValue("nganHang", nganHang);
    };
    setFieldsValueByNhaCungCap(nhaCungCapName);
  }, [nhaCungCapName]);
  useEffect(() => {
    if (isValuable(idProposePay)) {
      dispatch(getDetailProposePay(idProposePay));
    } else {
      dispatch(setDetailPay(null));
    }
  }, [idProposePay]);

  useEffect(() => {
    if (toNumber(thucChi) > toNumber(tamUng)) {
      form.setFieldValue("hachToanType", 0);
      setTienDu(toNumber(thucChi) - toNumber(tamUng));
    } else if (toNumber(thucChi) < toNumber(tamUng)) {
      form.setFieldValue("hachToanType", 1);
      setTienDu(toNumber(tamUng) - toNumber(thucChi));
    } else {
      form.setFieldValue("hachToanType", null);
      setTienDu(0);
    }
  }, [thucChi, tamUng]);
  useEffect(() => {
    const _setTypeFormPay = detailProposePay => {
      if (detailProposePay) {
        dispatch(setTypeFormPay(LOAI_FORM.DA_TAO));
      } else {
        dispatch(setTypeFormPay(LOAI_FORM.TAO_MOI));
      }
    };
    _setTypeFormPay(detailProposePay);
  }, [detailProposePay]);
  useEffect(() => {
    const setOptionsPhuongThuc = () => {
      const listOptions = getItemLocalStorage("hinhThucThanhToan")?.map(e => ({
        value: e?.id,
        label: e?.name,
        key: randomId(),
      }));
      fields.find(e => e?.name === "phuongThucThanhToan").options = listOptions;
      setFields([...fields]);
    };
    setOptionsPhuongThuc();
  }, []);
  useEffect(() => {
    const setFormValues = detailProposePay => {
      if (!detailProposePay) {
        form.resetFields();
        form.setFieldValue("chiTietPhieuDeNghiMuaSamDtos", []);
        form.setFieldValue("trangThaiStr", "Đang tạo đề nghị");
        setDataTable([]);
      }
      const formatDataTable = toArray(
        detailProposePay?.chiTietPhieuDeNghiMuaSamDtos
      )?.map(e => ({
        ...e,
        key: randomId(),
        ngayHoaDon: convertDateStringToDateTimezone_7(e?.ngayHoaDon),
      }));
      const formatData = {
        ...detailProposePay,
        timeLine: convertDateStringToDateTimezone_7(detailProposePay?.timeLine),
        trangThai: detailProposePay?.trangThai ?? 0,
        chiTietPhieuDeNghiMuaSamDtos: formatDataTable,
      };

      form.setFieldsValue(formatData);
      setDataTable(formatDataTable);
      _setTongTien();
    };
    setFormValues(detailProposePay);
    _setTongTien();
  }, [detailProposePay]);
  useEffect(() => {
    const showFields = detailProposePay => {
      fields.find(e => e?.name == "lyDoTuChoi").hide =
        !detailProposePay?.lyDoTuChoi;
    };
    showFields(detailProposePay);
  }, [detailProposePay]);
  const _setTongTien = () => {
    let _tongTien: any = 0;
    form?.getFieldValue("chiTietPhieuDeNghiMuaSamDtos")?.forEach(e => {
      _tongTien += toNumber(e?.thanhTien);
    });
    setTongTien(_tongTien);
  };
  const saveBtn = () => {
    return (
      <Button
        type="primary"
        onClick={() => {
          submit();
        }}
      >
        Lưu lại
      </Button>
    );
  };

  const sendBtn = () => {
    return (
      <>
        {(detailProposePay?.trangThai == TRANG_THAI_MUA_SAM.NHAP ||
          !detailProposePay?.trangThai) && (
          <Button
            type="primary"
            onClick={() => {
              modalSendRef?.current?.openModal();
            }}
          >
            Gửi
          </Button>
        )}
      </>
    );
  };
  const approveBtn = () => {
    return (
      <>
        {(detailProposePay?.trangThai == TRANG_THAI_MUA_SAM.CHO_DUYET ||
          detailProposePay?.trangThai ==
            TRANG_THAI_MUA_SAM.TRUONG_BP_DA_DUYET ||
          detailProposePay?.trangThai ==
            TRANG_THAI_MUA_SAM.KE_TOAN_DA_DUYET) && (
          <Button
            type="primary"
            onClick={() => {
              modalApproveRef?.current?.openModal();
            }}
          >
            Phê duyệt
          </Button>
        )}
      </>
    );
  };
  const denyBtn = () => {
    return (
      <>
        {(detailProposePay?.trangThai == TRANG_THAI_MUA_SAM.CHO_DUYET ||
          detailProposePay?.trangThai ==
            TRANG_THAI_MUA_SAM.TRUONG_BP_DA_DUYET ||
          detailProposePay?.trangThai ==
            TRANG_THAI_MUA_SAM.KE_TOAN_DA_DUYET) && (
          <Button
            danger
            type="primary"
            onClick={() => {
              modalDenyRef?.current?.openModal();
            }}
          >
            Từ chối
          </Button>
        )}
      </>
    );
  };
  const saveAndPrintBtn = () => {
    return (
      <Button
        icon={<PrintColorWhiteSVG />}
        className="btn-sub"
        onClick={() => {
          submit();
          modalPrintRef?.current?.openModal();
        }}
      >
        Lưu và in
      </Button>
    );
  };
  const printShoppingBtn = () => {
    return (
      <>
        {isValuable(detailProposePay?.idPhieuDeNghiMuaSam) && (
          <Button
            icon={<PrintColorWhiteSVG />}
            className="btn-sub"
            onClick={() => {
              submit();
              dispatch(
                getDetailProposeShopping(detailProposePay?.idPhieuDeNghiMuaSam)
              );
              modalShoppingPrintRef?.current?.openModal();
            }}
          >
            In phiếu mua sắm
          </Button>
        )}
      </>
    );
  };

  const submit = async (values = null, notification = "Đã lưu thành công") => {
    try {
      const formValues = await getFormValues();
      if (!formValues) {
        return;
      }
      let data = {
        ...detailProposePay,
        ...formValues,
        ...values,
        timeLine: formatDateToString(
          formValues?.timeLine,
          FORMAT_TIME.invertDayFull
        ),
        trangThai: values?.trangThai ?? detailProposePay?.trangThai ?? 0,
        tongTien: tongTien,
      };
      setIsLoading(true);
      const callApi =
        typeFormPay == LOAI_FORM.DA_TAO
          ? shoppingService.updateProposePay
          : shoppingService.createProposePay;
      const res = await callApi(data, detailProposePay?.id);

      dispatch(setDetailPay(res));
      setIsLoading(false);
      Notification("success", notification);
    } catch (error) {
      setIsLoading(false);
      Notification("error", error?.response?.data ?? "Đã có lỗi");
    }
  };

  const getFormValues = async () => {
    try {
      const formValues = await form.validateFields();
      return {
        ...formValues,
        soTienTamUng: toNumber(formValues?.soTienTamUng),
        chiTietPhieuDeNghiMuaSamDtos:
          formValues?.chiTietPhieuDeNghiMuaSamDtos?.map(e => ({
            ...e,
            ngayHoaDon: formatDateToStringTimezone_7(e?.ngayHoaDon, true),
          })),
      };
    } catch (error) {
      return null;
    }
  };

  useEffect(() => {
    if (activeTab == tabKeys.PROPOSE_PAY.DETAIL) {
      dispatch(
        setButtonsHeader([
          saveAndPrintBtn(),
          saveBtn(),
          sendBtn(),
          approveBtn(),
          denyBtn(),
          printShoppingBtn(),
        ])
      );
    } else {
      dispatch(setButtonsHeader([]));
    }
  }, [activeTab, detailProposePay, typeFormPay]);
  const hoanUng = Form.useWatch("hoanUng", form);
  const soTienTamUng = Form.useWatch("soTienTamUng", form);
  useEffect(() => {
    if (isValuable(hoanUng)) {
      form.setFieldValue("soTienTamUng", 0);
    }
  }, [hoanUng]);
  useEffect(() => {
    if (soTienTamUng) {
      form.setFieldValue("hoanUng", null);
    }
  }, [soTienTamUng]);

  return (
    <Spin spinning={isLoading}>
      <div className="detail-propose-pay">
        <Form form={form}>
          <div className="container ">
            <Typography.Text strong>Thông tin chung</Typography.Text>

            <Row gutter={[8, 8]}>
              <InputFields data={fields}></InputFields>
            </Row>
          </div>
          {detailProposePay && (
            <div className="container ">
              <Space>
                <Typography.Text strong>Hồ sơ đính kèm</Typography.Text>{" "}
                <Button
                  type="primary"
                  onClick={() => {
                    modalUploadRef?.current?.openModal();
                  }}
                >
                  Tải hồ sơ
                </Button>
              </Space>
              <div style={{marginTop: 12}}>
                <UploadHoSo ref={modalUploadRef} id={idProposePay}></UploadHoSo>
              </div>
            </div>
          )}

          <div className="container ">
            <Typography.Text strong>Chi phí dự kiến</Typography.Text>
            <TableInputAdd
              scroll={{x: 1000}}
              data={dataTable}
              setData={setDataTable}
              column={columns}
              name="chiTietPhieuDeNghiMuaSamDtos"
              form={form}
              isPagination={false}
              setTongTien={_setTongTien}
              setIdSelectedItem={setIdSelectedItem}
              isViewHistoryPay={
                detailProposePay?.trangThai == TRANG_THAI_MUA_SAM.GD_DA_DUYET
              }
            ></TableInputAdd>
            <Row style={{marginTop: 20}}>
              <Col span={12}>
                <div style={{display: "flex", justifyContent: "center"}}>
                  <div style={{width: "400px", wordWrap: "break-word"}}>
                    <Space
                      direction="vertical"
                      size={12}
                      style={{width: "100%"}}
                    >
                      <Row justify={"space-between"}>
                        <Col>
                          <Typography.Text strong>
                            Tổng tiền (VNĐ):
                          </Typography.Text>
                        </Col>
                        <Col>
                          <Typography.Text strong>
                            {formatToCurrencyTypeToFixed(tongTien)}
                          </Typography.Text>
                        </Col>
                      </Row>
                      <Row justify={"space-between"}>
                        <Col>
                          <Typography.Text strong>
                            Tiền tạm ứng (VNĐ):{" "}
                          </Typography.Text>
                        </Col>
                        <Col>
                          {" "}
                          <Typography.Text strong>
                            {formatToCurrencyTypeToFixed(
                              toNumber(soTienTamUng),
                              0
                            )}
                          </Typography.Text>
                        </Col>
                      </Row>
                      <Row justify={"space-between"}>
                        <Col>
                          <Typography.Text strong>
                            Tiền còn lại (VNĐ):{" "}
                          </Typography.Text>
                        </Col>
                        <Col>
                          <Typography.Text strong>
                            {formatToCurrencyTypeToFixed(
                              Math.abs(
                                toNumber(tongTien) - toNumber(soTienTamUng)
                              ),
                              0
                            )}
                          </Typography.Text>
                        </Col>
                      </Row>
                    </Space>
                    <Row justify={"start"} style={{marginTop: 12}}>
                      <Typography.Text strong>
                        Tiền còn lại bằng chữ:{" "}
                        {capitalizeFirstLetter(
                          convertCurrencyToWords(
                            toNumber(
                              Math.abs(
                                toNumber(tongTien) - toNumber(soTienTamUng)
                              )
                            ).toFixed(0)
                          )
                        )}
                      </Typography.Text>
                    </Row>
                  </div>
                </div>
              </Col>
              <Col span={12}>
                <div style={{display: "flex", justifyContent: "center"}}>
                  <div style={{width: 250}}>
                    <Typography.Text strong>Hạch toán tạm ứng</Typography.Text>
                    <Form.Item name="hachToanType">
                      <Radio.Group
                        disabled
                        style={{width: "100%"}}
                        size="middle"
                      >
                        <Row
                          style={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-between",
                          }}
                        >
                          <Radio value={0}>{"Nhận thêm tiền"}</Radio>
                          <Typography.Text strong>
                            {form.getFieldValue("hachToanType") == 0 &&
                              `${formatToCurrencyTypeToFixed(tienDu)} đ`}
                          </Typography.Text>
                        </Row>
                        <Row
                          style={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-between",
                          }}
                        >
                          <Radio value={1}>{"Hoàn trả cho công ty"}</Radio>
                          <Typography.Text strong>
                            {form.getFieldValue("hachToanType") == 1 &&
                              `${formatToCurrencyTypeToFixed(tienDu)} đ`}
                          </Typography.Text>
                        </Row>
                      </Radio.Group>
                    </Form.Item>
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          {idSelectedItem && (
            <div className="container">
              <Typography.Text strong>Theo dõi thanh toán</Typography.Text>
              <TableInputAddThanhToan
                column={columnsThanhToan}
                form={formThanhToan}
                isPagination={false}
                idSelectedItem={idSelectedItem}
                scroll={{x: 600}}
              ></TableInputAddThanhToan>
            </div>
          )}
          <ModalCustom
            ref={modalSendRef}
            width={600}
            title="Gửi yêu cầu phê duyệt"
          >
            <ModalSend submit={submit} isLoading={isLoading}></ModalSend>
          </ModalCustom>
          <ModalCustom
            ref={modalApproveRef}
            width={600}
            title="Phê duyệt yêu cầu"
          >
            <ModalApprove submit={submit} isLoading={isLoading}></ModalApprove>
          </ModalCustom>
          <ModalCustom ref={modalDenyRef} width={600} title="Từ chối yêu cầu">
            <ModalDeny submit={submit} isLoading={isLoading}></ModalDeny>
          </ModalCustom>
          <ModalCustom
            title="Phiếu đề nghị thanh toán"
            isLoading={isLoading}
            ref={modalPrintRef}
            width={1000}
          >
            <ReceiptModal></ReceiptModal>
          </ModalCustom>
          <ModalCustom
            title="Phiếu đề nghị mua sắm"
            isLoading={isLoading}
            ref={modalShoppingPrintRef}
            width={1000}
          >
            <ReceiptShoppingModal></ReceiptShoppingModal>
          </ModalCustom>
        </Form>
      </div>
    </Spin>
  );
};
export default DetailProposePay;
